import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { Router } from "@angular/router";
import { LoggedInUser } from "../models/user";
import { IdentityResultViewModel } from "../models/register-result-view-model";
import { UserDataStoreService } from "./user-data-store.service";
import { ParticipantRoleAndPermissionsViewModel } from "../models/participant-role-and-permissions-view-model";
import { RefreshSessionViewModel } from "../models/refresh-session-view-model";
import { CreateResult } from '../models/create-result';
import { PagedResponse } from '../models/paged-response';
import { SearchFilterModel } from '../models/search-filter-model';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private _httpService: HttpService,
    private _router: Router,
    private _userDataStore: UserDataStoreService
  ) {

  }

  public async login1(email: string, password: string, rememberMe: boolean): Promise<any> {
    const httpResult = await this._httpService.apiPost<any>(`authentication/login`, {
      EmailAddress: email,
      Password: password,
      RememberMe: rememberMe
    });

    if (httpResult && httpResult.body) {
      const user = httpResult.body;
    debugger;
      if (user.requires2FA) {
        // store temporarily (e.g. sessionStorage)
        sessionStorage.setItem('2fa_user_id', user.id);
        return { success: true, requires2FA: true };
      }

      this._userDataStore.UpdateUser(user);
      return { success: true };
    }

    return { success: false, message: "Username or password is invalid or account is inactive." };
  }

  public async login2(email: string, password: string, rememberMe: boolean): Promise<CreateResult> {
    try {
      const httpResult = await this._httpService.apiPost<LoggedInUser>(`authentication/login`, {
        EmailAddress: email,
        Password: password,
        RememberMe: rememberMe
      });

      if (httpResult?.body) {
        this._userDataStore.UpdateUser(httpResult.body);
        return { message: "success", success: true };
      }

      return {
        message: "Unexpected response from server",
        success: false
      };

    } catch (error) {
      if (error.status === 401) {
        return {
          message: "Username or password is invalid or account is inactive.",
          success: false
        };
      }

      console.error("Login error:", error);
      return {
        message: "An unexpected error occurred.",
        success: false
      };
    }
  }


  public async login(email: string, password: string, rememberMe: boolean): Promise<any> {
    const httpResult = await this._httpService.apiPost<any>(`authentication/login`, {
      EmailAddress: email,
      Password: password,
      RememberMe: rememberMe
    });

    if (httpResult && httpResult.body) {
      if (httpResult.body.requires2FA) {
        const user = httpResult.body;
        sessionStorage.setItem('2fa_user_id', user.id);
        return {
          success: true,
          requires2FA: true,
          userId: httpResult.body.userId
        };
      }

      this._userDataStore.UpdateUser(httpResult.body);
      return { message: "success", success: true };
    }

    return { message: "Invalid credentials", success: false };
  }



  // public async login(email: string, password: string, rememberMe: boolean): Promise<CreateResult> {
  //   debugger;
  //   const httpResult = await this._httpService.apiPost<LoggedInUser>(`authentication/login`, {
  //     EmailAddress: email,
  //     Password: password,
  //     RememberMe: rememberMe
  //   });
  //   debugger;
  //   if (httpResult && httpResult.body) {
  //     this._userDataStore.UpdateUser(httpResult.body);
  //     debugger;
  //     return { message: "success", success: true };
  //   }
  //   debugger;
  //   return { message: "Username or password is Invalid or Account is inactive. Contact System administrator if error persist!", success: false };
  // }

  public async refreshSession(participantId?: number): Promise<boolean> {
    let participant = this._userDataStore.selectedParticipant.id;
    if (participantId) {
      participant = participantId;
    }
    const refreshSessionViewModel: RefreshSessionViewModel = {
      participantId: participant,
      refreshToken: this._userDataStore.currentUserValue.refreshToken,
      token: this._userDataStore.currentUserValue.token
    };
    const httpResult = await this._httpService.apiPostRefreshToken<LoggedInUser>(`authentication/refresh`, refreshSessionViewModel);
    if (httpResult && httpResult.body) {
      this._userDataStore.UpdateUser(httpResult.body);
      return true;
    }
    return false;
  }

  public async logout(): Promise<void> {
    this._userDataStore.Clear();
    await this._router.navigate(['account', 'login']).then(() => window.location.reload());
  }

  public async GetParticipantRolesAndPermissions(filter: SearchFilterModel): Promise<PagedResponse<ParticipantRoleAndPermissionsViewModel>> {
    const httpResult = await this._httpService.apiPost<PagedResponse<ParticipantRoleAndPermissionsViewModel>>(`authentication/rolesAndPermissions`, filter);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {
      response: null,
      total: 0
    };
  }

  public async InsertOrUpdateRoleWithPermissions(roleAndPermissionsViewModel: ParticipantRoleAndPermissionsViewModel): Promise<ParticipantRoleAndPermissionsViewModel> {
    const httpResult = await this._httpService.apiPost<ParticipantRoleAndPermissionsViewModel>(`authentication/InsertOrUpdateRoleWithPermissions`, roleAndPermissionsViewModel);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return roleAndPermissionsViewModel;
  }

  public async DeleteRole(roleAndPermissionsViewModel: ParticipantRoleAndPermissionsViewModel): Promise<IdentityResultViewModel> {
    const httpResult = await this._httpService.apiDelete<IdentityResultViewModel>(`authentication/DeleteRole/${roleAndPermissionsViewModel.role.id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { succeeded: false, errors: [] };
  }

  public getToken(): string {
    return this._userDataStore.currentUserValue?.token || '';
  }


}
